import type { MarketResolutionThresholdState } from './resolution-threshold.js';

export interface MarketResolutionThresholdConsumers {
  readonly chartResolutionThreshold: number | undefined;
  readonly goalPercent: number | undefined;
  readonly infoConsensusThreshold: string | null;
  readonly resolutionCardThreshold: number | null;
}

export interface MarketResolutionThresholdConsumersOptions {
  /** Outcome cards show `/goal%`. Live-event rows hide it (calendar end is the clock). */
  readonly showGoalPercent?: boolean;
}

/** Fan-out from one resolution-threshold clock to chart, outcomes, info, and the card. */
export function marketResolutionThresholdConsumers(
  resolutionThreshold: MarketResolutionThresholdState,
  options: MarketResolutionThresholdConsumersOptions = {},
): MarketResolutionThresholdConsumers {
  if (resolutionThreshold.kind !== 'ready') {
    return {
      chartResolutionThreshold: undefined,
      goalPercent: undefined,
      infoConsensusThreshold: null,
      resolutionCardThreshold: null,
    };
  }
  const consensusThreshold: number = resolutionThreshold.thresholdFraction;
  const showGoalPercent: boolean = options.showGoalPercent !== false;
  return {
    chartResolutionThreshold: consensusThreshold,
    goalPercent:
      showGoalPercent && consensusThreshold > 0 ? resolutionThreshold.thresholdPercent : undefined,
    infoConsensusThreshold: resolutionThreshold.thresholdPpb.toString(),
    resolutionCardThreshold: consensusThreshold,
  };
}
